import FormValidationStrategy from "../strategy/FormValidationStrategy.js";

export default class PasswordFormValidationStrategy extends FormValidationStrategy{
    validate(valueString) {
        const value = valueString
            .toString()
            .trim(),
            passwordRegex = /^(?=.*[a-zA-Z])(?=.*\d).{5,}$/
        ;
        let isValid = false;

        if (!value.length) {
            return {
                isValid,
                message: this.loadErrorMessage("empty", "Пароль")
            }
        }

        if (!passwordRegex.test(value)) {
            return {
                isValid,
                message: this.loadErrorMessage("regexp", "Пароль")
            }
        }

        isValid = true;
        return {
            isValid,
            message: ""
        }
    }
}
